import type { IncidentSeverity } from '../api/types'

export const STATUSES = ['Open', 'UnderReview', 'Resolved'] as const
export type IncidentStatusValue = (typeof STATUSES)[number]

export const ALLOWED_TRANSITIONS: Record<IncidentStatusValue, IncidentStatusValue[]> = {
  Open: ['UnderReview', 'Resolved'],
  UnderReview: ['Open', 'Resolved'],
  Resolved: ['Open', 'UnderReview'],
}

export const STATUS_LABELS: Record<IncidentStatusValue, string> = {
  Open: 'Open',
  UnderReview: 'Under Review',
  Resolved: 'Resolved',
}

export const SEVERITY_COLORS: Record<IncidentSeverity, { bg: string; fg: string; ring: string }> = {
  Low:      { bg: 'bg-blue-100 dark:bg-blue-500/15',     fg: 'text-blue-900 dark:text-blue-300',     ring: 'ring-blue-400' },
  Medium:   { bg: 'bg-amber-100 dark:bg-amber-500/15',   fg: 'text-amber-900 dark:text-amber-300',   ring: 'ring-amber-400' },
  High:     { bg: 'bg-orange-100 dark:bg-orange-500/15', fg: 'text-orange-900 dark:text-orange-300', ring: 'ring-orange-400' },
  Critical: { bg: 'bg-red-100 dark:bg-red-500/15',       fg: 'text-red-900 dark:text-red-300',       ring: 'ring-red-400' },
}

export const LOCATION_UNCONFIRMED_LABEL = 'Location unconfirmed'

export const STATUS_COLORS: Record<IncidentStatusValue, { bg: string; fg: string }> = {
  Open:        { bg: 'bg-blue-100 dark:bg-blue-500/15',   fg: 'text-blue-900 dark:text-blue-300' },
  UnderReview: { bg: 'bg-amber-100 dark:bg-amber-500/15', fg: 'text-amber-900 dark:text-amber-300' },
  Resolved:    { bg: 'bg-green-100 dark:bg-green-500/15', fg: 'text-green-900 dark:text-green-300' },
}
